<template>
  <v-container fluid class="mt-0 pt-0">
    <v-form lazy-validation ref="form" v-model="formValid">
      <v-row style="user-select:none" class="mt-0 pt-0">
        <v-col cols="12">
          <span class="menuTitle">Meu Perfil</span><br />
          <span class="menuSubtitle"
            >Altere as informações de seu usuário.</span
          >
        </v-col>
        <v-col cols="12" md="7">
          <v-text-field
            v-model="userInfo.name"
            label="Nome Completo"
            name="name"
            :rules="rules.name"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="7">
          <v-text-field
            v-model="userInfo.email"
            disabled
            label="E-mail"
            name="email"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn
            :loading="loading"
            color="success"
            style="float:right"
            v-on:click="updateUserDetails()"
            right
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-snackbar
        top
        right
        v-model="updateStatus.show"
        :color="updateStatus.color"
        :timeout="5000"
      >
        {{ updateStatus.message }}
      </v-snackbar>
    </v-form>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Axios from "axios";

export default {
  name: "UserProfile",
  components: {},
  data: () => ({
    formValid: true,
    userInfo: {
      name: "",
      email: ""
    },
    rules: {
      name: [
        (v) => !!v || "Um nome é Obrigatório",
        (v) => (v && v.length >= 8) || "Informe o Nome completo",
        (v) =>
          (v && (v.match(/\s\w/g) || []).length >= 1) ||
          "Informe o Nome completo"
      ]
    },
    loading: false,
    updateStatus: {
      show: false,
      color: "",
      message: ""
    }
  }),
  computed: {},
  methods: {
    getUserDetails: function() {
      Axios.get("/api/v1/profile/user/details").then((response) => {
        this.userInfo = response.data.data;
      });
    },
    updateUserDetails: function() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        Axios.put("/api/v1/profile/user/details", {
          name: this.userInfo.name
        }).then((response) => {
          const data = response.data;
          if (data.status == "success") {
            this.getUserDetails();
            this.$store.dispatch("appStore/getUserName");
          }
          this.updateStatus.message = data.msg;
          this.updateStatus.color =
            data.status == "success" ? "success" : "error";
          this.updateStatus.show = true;
          this.loading = false;
        });
      }
    }
  },
  mounted() {
    this.getUserDetails();
  }
};
</script>
<style>
.menuTitle {
  font-size: 20px;
  color: #132237;
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 3px #60ba8e45 solid;
}
.menuSubtitle {
  font-size: 14px;
  font-weight: 300;
  color: #000000ba;
}
</style>
